import * as React from 'react'
import AnimateHeight from 'react-animate-height'
import './PetDrawer.css'
// import { useSwipeable } from 'react-swipeable'
import drawerStore from '../../store/drawerStore.ts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { clearRoute } from '../map/Directions/directionHelper.tsx'
import mapStore from '../../store/mapStore.ts'

// const getVal = (px: string) => parseInt(px.split('px')[0])
// const heightPresets = [20, 80, 160, 240, 330, 400]
export const PetDrawer: React.FC = () => {
    const height = drawerStore(s => s.drawerSize)
    const children = drawerStore(s => s.children)
    const travelMode = mapStore(s => s.travelMode)

    return (
        <div>
            <AnimateHeight
                id="pet-drawer"
                duration={500}
                height={height as any}
                className={'w-[100vw] max-h-[88vh] overflow-y-auto pointer-events-auto'}
            >
                <div className={'bg-transparent h-auto min-h-[100px] pb-[12vh]'}>
                    {children}
                    {drawerStore.getState().children === null ? (
                        <div id="directions-header" className={'w-full flex flex-row justify-between items-center border-b-2 border-b-primary mb-2'}>
                            <div className={'p-2 text-md font-semibold text-primary'}>
                                {travelMode} Directions
                            </div>
                            <div
                                className={'pr-4 cursor-pointer'}
                                onClick={() => clearRoute()}>
                                <FontAwesomeIcon icon={faClose} fontSize={'medium'} size={'lg'}/>
                            </div>
                        </div>
                    ) : null}
                </div>
            </AnimateHeight>
        </div>
    )
}
